module.exports = __webpack_public_path__ + "img/stlucia.0960913d.svg";